import React from "react";
import styles from "./MainButton.module.scss";

const MainButton = ({ disabled, onClick, className, children }: any) => {
  return (
    <button
      className={`${styles.mainButton} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default MainButton;
